export default function () {
  
  let $interstitial = $(".js-exhibition-interstitial");

  if (localStorage.getItem("interstitialExhibitionSeen") === "true") {
    $interstitial.remove();
  } else {
    setTimeout(() => {
      $interstitial.modal("show");
      $interstitial.on("hidden.bs.modal", () => {
        $interstitial.modal("hide");
        $interstitial.remove();
        localStorage.setItem("interstitialExhibitionSeen", "true");
      });
    }, 100);
  }
}
